import { render, staticRenderFns } from "./Forfatter.vue?vue&type=template&id=030a759a&"
import script from "./Forfatter.vue?vue&type=script&lang=js&"
export * from "./Forfatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('030a759a', component.options)
    } else {
      api.reload('030a759a', component.options)
    }
    module.hot.accept("./Forfatter.vue?vue&type=template&id=030a759a&", function () {
      api.rerender('030a759a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/lf_forfatter/Forfatter.vue"
export default component.exports